import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

interface SideNavProps {
  onNavigate?: () => void;
}

const navItems = [
  { to: "/", label: "首页", en: "HOME", icon: "ri-home-5-line" },
  { to: "/category", label: "影视分类", en: "CATEGORY", icon: "ri-film-line" },
  { to: "/news", label: "资讯专题", en: "NEWS", icon: "ri-newspaper-line" },
  { to: "/about", label: "关于", en: "ABOUT", icon: "ri-information-line" },
];

export default function SideNav({ onNavigate }: SideNavProps) {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const key = keyword.trim();
    navigate(key ? `/category?q=${encodeURIComponent(key)}` : "/category");
    setKeyword("");
    if (onNavigate) onNavigate();
  };

  return (
    <div className="flex h-full flex-col bg-primary-950 text-background-50">
      <div className="px-6 pt-7 pb-6 border-b border-background-50/10">
        <NavLink to="/" onClick={onNavigate} className="flex items-center gap-3 cursor-pointer">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
            <i className="ri-movie-2-fill text-2xl"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-bold tracking-wide">出轨的味道</span>
            <span className="font-label text-[10px] tracking-[0.28em] text-background-50/50">TASTE OF BETRAYAL</span>
          </span>
        </NavLink>
      </div>

      <nav className="flex-1 overflow-y-auto px-4 py-5">
        <p className="px-2 pb-3 font-label text-[10px] tracking-[0.3em] text-background-50/40">NAVIGATION</p>
        <ul className="flex flex-col gap-1.5">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === "/"}
                onClick={onNavigate}
                className={({ isActive }) =>
                  `group flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors cursor-pointer ${
                    isActive
                      ? "bg-accent-500 text-primary-950 font-medium"
                      : "text-background-50/75 hover:bg-background-50/10 hover:text-background-50"
                  }`
                }
              >
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <span className="flex-1">{item.label}</span>
                <span className="font-label text-[10px] tracking-widest opacity-50">{item.en}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="mt-7 px-1">
          <p className="px-1 pb-3 font-label text-[10px] tracking-[0.3em] text-background-50/40">SEARCH</p>
          <form onSubmit={handleSubmit} className="relative">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-background-50/50">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="text"
              placeholder="搜索剧名 / 关键词"
              aria-label="站内搜索"
              className="w-full rounded-md border border-background-50/15 bg-background-50/5 py-2.5 pl-9 pr-3 text-sm text-background-50 placeholder:text-background-50/40 focus:border-accent-500 focus:outline-none"
            />
          </form>
        </div>
      </nav>

      <div className="border-t border-background-50/10 px-6 py-5">
        <p className="text-xs leading-relaxed text-background-50/50">
          出轨的味道 · 影视内容站
          <br />
          剧情 · 演员 · 资讯
        </p>
      </div>
    </div>
  );
}